<div class="wncModal">
    <div class="panelHeader">
      <div class="row">
        <div class="col-md-9 panelTitle">
          <div class="col-md-12 no-pad">
            <h3 class="white-text header-padding-left">Set Start Dates For Tracking Items</h3>
          </div>
        </div>      
        <div class="col-md-3 panelButton">
          <button type="button"  class="btn btn-outline-primary white-background"  (click)="confirmStartDates()"><i class="fa fa-plus" aria-hidden="true"></i> &#160;Confirm</button>
          <button type="button" class="btn btn-outline-danger white-background" (click)="closeModal()"><i class="fa fa-times" aria-hidden="true"></i> &#160;Close</button>
        </div>
      </div>
    </div>  
    <div class="panelBody">
      <div class="col-md-12 table-header">
        <div class="row">
          <div class="col-md-4 align-center bold-header header-text-size">
            <span>Tracking Item</span>
          </div>
          <div class="col-md-4 align-center bold-header header-text-size">
            <span >Frequency</span>
          </div>
           <div class="col-md-4 align-center bold-header header-text-size">
            <span class="required">Start Date</span>
          </div>
         
        </div>
      </div>

      <div class="col-md-12 table-content">
        <div class="row formInput" *ngFor="let item of trackingItems; let ndx = index" style="padding-bottom: 4px;">
          <div class="col-md-4" style="padding-right: 3px;">
            <input type="text" class="form-control align-right " [(ngModel)]="item.trackingItemName" [disabled] = "true" />
          </div>
          <div class="col-md-4 no-pad slight-right-input-padding required">
            <select [disabled]="true" class="form-control align-center" [(ngModel)]="item.frequencyTypeID">
                <option value="{{0}}"></option>
                <option *ngFor="let ft of frequencyTypeList" [value]="ft.frequencyTypeID">{{ft.frequencyTypeName}}</option>
            </select>
          </div>
          <div class="col-md-4 no-pad">
            <div class="no-pad input-group" >
              <input class="form-control" [(ngModel)]="item.startDate" ngbDatepicker #d="ngbDatepicker"
              [minDate]="{year: 1900, month: 1, day: 1}"
              [maxDate]="{year: 2099, month: 12, day: 31}"
              (blur)="checkStartDate(item);" [readonly]="true" >
               
              <div class="input-group-append">
                  <button style="height: 38px !important;" class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
              </div>
          </div>
          <!--<span class="error-text" *ngIf="">
              This field is required
          </span>-->
          </div>
         
          </div>
        </div>
      </div>
    </div>
